var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechnologyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#DDF6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9987 13.4615L9.22942 11.3461L9.03711 18.6538L14.9987 20.5769V13.4615Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0405 10.4782L15.1652 8.4815C15.0262 8.45473 14.9138 8.45473 14.8042 8.4815L8.92629 10.4809C8.4476 10.6281 8.46097 11.0055 8.46097 11.0162V18.7005C8.46097 18.9226 8.60003 19.118 8.82199 19.201L14.8042 21.5108C14.9112 21.5563 15.1385 21.5376 15.1946 21.5108L21.1768 19.2036C21.3988 19.1207 21.5379 18.9253 21.5379 18.7031V11.0162C21.5379 10.8502 21.4362 10.529 21.0405 10.4782ZM14.9994 9.56816L19.3958 11.0429L14.9994 12.7158L10.603 11.0429L14.9994 9.56816ZM9.5467 18.3124V11.8245L14.4432 13.69V20.2047L9.5467 18.3124ZM20.4521 18.3124L15.5557 20.2047V13.7061L20.4521 11.8245V18.3124Z",
    fill: "#1DC4D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnologyIcon);
export default __webpack_public_path__ + "static/media/technology-icon.f3c42882.svg";
export { ForwardRef as ReactComponent };